import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useSystemUsersUIContext } from "../SystemUsersUIContext";
import { SystemUserConfirmationOptions, SystemUserStatusOptions } from "../SystemUsersUIHelpers";
import { CustomSelect } from "../../../../../../_helpers/Helpers";

const prepareFilter = (queryParams, values) => {
  const { name, surname, username, isSuperAdmin, isActive } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by name
  filter.name = name;
  // Filter by surname
  filter.surname = surname;
  // Filter by username
  filter.username = username;
  // Filter by isSuperAdmin
  filter.isSuperAdmin = isSuperAdmin;
  // Filter by isActive
  filter.isActive = isActive;
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SystemUsersFilter() {
  // SystemUsers UI Context
  const systemUsersUIContext = useSystemUsersUIContext();
  const systemUsersUIProps = useMemo(() => {
    return {
      setQueryParams: systemUsersUIContext.setQueryParams,
      queryParams: systemUsersUIContext.queryParams,
    };
  }, [systemUsersUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(systemUsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, systemUsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      systemUsersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: "",
        surname: "",
        username: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="username"
                placeholder="Kullanıcı Adı"
                onBlur={handleBlur}
                value={values.username}
                onChange={(e) => {
                  setFieldValue("username", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={SystemUserConfirmationOptions}
                value={values.isSuperAdmin}
                placeholder="Super Admin"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isSuperAdmin", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>SuperAdmin</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={SystemUserStatusOptions}
                value={values.isActive}
                placeholder="Aktif mi?"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isActive", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Aktif mi?</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}